<template>
  <div class="mt-3">
    <div class="row" style="margin: -20px;">
      <!-- Columna 1: Datos principales -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <strong><i class="fa fa-info-circle me-2"></i>Datos Generales</strong>
          </div>
          <div class="card-body">
            <table class="table table-sm table-borderless">
              <tr>
                <td width="40%"><strong>Código:</strong></td>
                <td><span class="badge bg-primary">{{ solicitud.codigo || 'N/A' }}</span></td>
              </tr>
              <tr>
                <td><strong>Tipo:</strong></td>
                <td><BBadge :variant="getTipoVariant(solicitud.tipo_contratacion)">{{ formatTipo(solicitud.tipo_contratacion) }}</BBadge></td>
              </tr>
              <tr>
                <td><strong>Unidad:</strong></td>
                <td>{{ solicitud.unidad_solicitante?.nombre_unidad || 'N/A' }}</td>
              </tr>
              <tr>
                <td><strong>Solicitante:</strong></td>
                <td>{{ solicitud.usuario_solicitante?.nombres || 'N/A' }} {{ solicitud.usuario_solicitante?.paterno || '' }} {{ solicitud.usuario_solicitante?.materno || '' }}</td>
              </tr>
              <tr>
                <td><strong>Fecha Registro:</strong></td>
                <td>{{ formatDateTime(solicitud.fecha_registro) }}</td>
              </tr>
              <tr>
                <td><strong>Monto Estimado:</strong></td>
                <td class="text-success fw-bold">Bs. {{ formatNumber(montoEstimado) }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- Columna 2: Datos específicos -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-header bg-light">
            <strong><i class="fa fa-gears me-2"></i>Especificaciones</strong>
          </div>
          <div class="card-body">
            <table class="table table-sm table-borderless">
              <tr>
                <td width="40%"><strong>Código PAC:</strong></td>
                <td>{{ solicitud.codigo_pac || 'N/A' }}</td>
              </tr>
              <tr>
                <td width="40%"><strong>Código POA:</strong></td>
                <td>{{ solicitud.codigo_poa || 'N/A' }}</td>
              </tr>
              <tr>
                <td><strong>Método:</strong></td>
                <td>{{ solicitud.metodo_seleccion || 'No definido' }}</td>
              </tr>
              <tr>
                <td><strong>Plazo Entrega:</strong></td>
                <td>{{ solicitud.plazo_entrega_dias || 'N/A' }} días</td>
              </tr>
              <tr>
                <td><strong>Lugar Entrega:</strong></td>
                <td>DDE-Beni</td>
              </tr>
              <tr>
                <td><strong>Estado Actual:</strong></td>
                <td><BBadge :variant="getEstadoVariant(solicitud.estado)">{{ formatEstado(solicitud.estado) }}</BBadge></td>
              </tr>
              <tr v-if="solicitud.observacion_rechazo">
                <td><strong>Observación Rechazo:</strong></td>
                <td class="text-danger">{{ solicitud.observacion_rechazo }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- Columna 3: Recurso asignado -->
      <div class="col-md-4">
        <div class="card" v-if="solicitud.recurso">
          <div class="card-header bg-light">
            <strong><i class="fa fa-money me-2"></i>Recurso Asignado</strong>
          </div>
          <div class="card-body">
            <table class="table table-sm table-borderless">
              <tr>
                <td width="40%"><strong>Fuente:</strong></td>
                <td>{{ solicitud.recurso?.fuente_financiamiento || 'N/A' }}</td>
              </tr>
              <tr>
                <td><strong>Programa POA:</strong></td>
                <td>{{ solicitud.recurso?.programa_poa || 'N/A' }}</td>
              </tr>
              <tr>
                <td><strong>Actividad POA:</strong></td>
                <td>{{ solicitud.recurso?.actividad_poa || 'N/A' }}</td>
              </tr>
              <tr>
                <td><strong>Monto Recurso:</strong></td>
                <td class="text-primary fw-bold">Bs. {{ formatNumber(solicitud.recurso.monto) }}</td>
              </tr>
              <tr>
                <td><strong>Descripción:</strong></td>
                <td>{{ solicitud.recurso.descripcion_recursos || 'N/A' }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-header bg-light">
            <strong><i class="fa fa-money me-2"></i>Recurso Asignado</strong>
          </div>
          <div class="card-body text-muted">
            No hay información de recurso asignado
          </div>
        </div>
      </div>
    </div>
    <br>
    <!-- Objeto y Justificación -->
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <strong><i class="fa fa-file-text me-2"></i>Objeto de la Contratación</strong>
            <BButton
                variant="danger"
                size="sm"
                @click="generarPdfSol"
                :disabled="generandoPdf"
                title="Generar Formulario Único de Solicitud (FUS)"
                >
                <i v-if="generandoPdf" class="fa fa-spinner fa-spin"></i>
                <i v-else class="fa fa-file-pdf"></i> FUS
            </BButton>
            <BButton
                variant="danger"
                size="sm"
                @click="generarPdfFus"
                :disabled="generandoPdf"
                title="Generar Nota Interna de solicitud de adquisición o contratación"
                >
                <i v-if="generandoPdf" class="fa fa-spinner fa-spin"></i>
                <i v-else class="fa fa-file-pdf"></i> Nota Solicitud
            </BButton>
          </div>
          <div class="card-body">
            <p class="mb-0">{{ solicitud.objeto || 'No especificado' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light">
            <strong><i class="fa fa-commenting me-2"></i>Justificación</strong>
          </div>
          <div class="card-body">
            <p class="mb-0">{{ solicitud.justificacion || 'No se registró justificación' }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Resumen de avance -->
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light">
            <strong><i class="fa fa-chart-line me-2"></i>Avance del Proceso</strong>
          </div>
          <div class="card-body">
            <div class="row text-center">
              <div class="col-md-2">
                <div class="p-2 border rounded" :class="getStepClass(1)">
                  <i class="fa fa-check-circle fa-2x" v-if="flujoCompletado.certificacion"></i>
                  <i class="fa fa-circle-o fa-2x" v-else></i>
                  <div class="mt-1"><small>Certificación</small></div>
                </div>
              </div>
              <!--
              <div class="col-md-2">
                <div class="p-2 border rounded" :class="getStepClass(2)">
                  <i class="fa fa-check-circle fa-2x" v-if="flujoCompletado.proceso_seleccion"></i>
                  <i class="fa fa-circle-o fa-2x" v-else></i>
                  <div class="mt-1"><small>Selección</small></div>
                </div>
              </div>
              -->
              <div class="col-md-2">
                <div class="p-2 border rounded" :class="getStepClass(3)">
                  <i class="fa fa-check-circle fa-2x" v-if="flujoCompletado.adjudicacion"></i>
                  <i class="fa fa-circle-o fa-2x" v-else></i>
                  <div class="mt-1"><small>Adjudicación</small></div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="p-2 border rounded" :class="getStepClass(4)">
                  <i class="fa fa-check-circle fa-2x" v-if="flujoCompletado.contratos"></i>
                  <i class="fa fa-circle-o fa-2x" v-else></i>
                  <div class="mt-1"><small>Contrato</small></div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="p-2 border rounded" :class="getStepClass(5)">
                  <i class="fa fa-check-circle fa-2x" v-if="flujoCompletado.recepciones"></i>
                  <i class="fa fa-circle-o fa-2x" v-else></i>
                  <div class="mt-1"><small>Recepción</small></div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="p-2 border rounded" :class="getStepClass(6)">
                  <i class="fa fa-check-circle fa-2x" v-if="flujoCompletado.informe_conclusion"></i>
                  <i class="fa fa-circle-o fa-2x" v-else></i>
                  <div class="mt-1"><small>Conclusión</small></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { BBadge, BButton } from 'bootstrap-vue-3';
import axios from 'axios';
import Swal from 'sweetalert2';

const props = defineProps({
  solicitud: {
    type: Object,
    required: true
  },
  recurso: {
    type: Object,
    default: null
  }
});

const generandoPdf = ref(false);

// Calcular monto estimado desde los detalles
const montoEstimado = computed(() => {
  if (!props.solicitud?.detalles?.length) return 0;
  return props.solicitud.detalles.reduce((sum, detalle) => {
    const cantidad = parseFloat(detalle.cantidad) || 0;
    const costoUnitario = parseFloat(detalle.costo_unitario) || 0;
    return sum + (cantidad * costoUnitario);
  }, 0);
});

// Verificar qué etapas del flujo están completadas
const flujoCompletado = computed(() => ({
  certificacion: !!props.solicitud?.certificacion,
  proceso_seleccion: !!props.solicitud?.proceso_seleccion,
  adjudicacion: !!props.solicitud?.adjudicacion,
  contratos: props.solicitud?.contratos?.length > 0,
  recepciones: props.solicitud?.recepciones?.length > 0,
  informe_conclusion: !!props.solicitud?.informe_conclusion
}));

/**
 * Generar PDF del Formulario Único de Solicitud (FUS)
 */
const generarPdfFus = async () => {
  generandoPdf.value = true;
  try {
    const response = await axios.get(`/solicitud-contratacion/pdf/fus/${props.solicitud.id}`, {
      responseType: 'blob'
    });

    // Crear URL del blob y descargar
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    const nombreArchivo = `FUS_${props.solicitud.codigo}.pdf`;

    link.href = blobUrl;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);

    Swal.fire('Éxito', 'Formulario Único de Solicitud generado correctamente', 'success');
  } catch (error) {
    console.error('Error al generar PDF:', error);
    Swal.fire('Error', error.response?.data?.message || 'No se pudo generar el PDF', 'error');
  } finally {
    generandoPdf.value = false;
  }
};

const generarPdfSol = async () => {
  generandoPdf.value = true;
  try {
    const response = await axios.get(`/solicitud-contratacion/pdf/sol/${props.solicitud.id}`, {
      responseType: 'blob'
    });

    // Crear URL del blob y descargar
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    const nombreArchivo = `nota_solicitud_${props.solicitud.codigo}.pdf`;

    link.href = blobUrl;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);

    Swal.fire('Éxito', 'Nota Interna de solicitud de adquisición o contratación generado correctamente', 'success');
  } catch (error) {
    console.error('Error al generar PDF:', error);
    Swal.fire('Error', error.response?.data?.message || 'No se pudo generar el PDF', 'error');
  } finally {
    generandoPdf.value = false;
  }
};

const getStepClass = (step) => {
  const steps = {
    1: flujoCompletado.value.certificacion,
    2: flujoCompletado.value.proceso_seleccion,
    3: flujoCompletado.value.adjudicacion,
    4: flujoCompletado.value.contratos,
    5: flujoCompletado.value.recepciones,
    6: flujoCompletado.value.informe_conclusion
  };

  if (steps[step]) {
    return 'bg-success bg-opacity-25 border-success';
  }
  return 'bg-light';
};

// Formateadores
const formatNumber = (n) => {
  if (n === undefined || n === null) return '0.00';
  return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2 }).format(n);
};

const formatDateTime = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleString('es-BO');
};

const formatTipo = (t) => {
  const tipos = {
    'BIENES': 'Bienes',
    'SERVICIOS': 'Servicios',
    'CONSULTORIA_LINEA': 'Consultoría Línea',
    'CONSULTORIA_PRODUCTO': 'Consultoría Producto'
  };
  return tipos[t] || t || 'N/A';
};

const formatEstado = (e) => {
  if (!e) return 'N/A';
  return e.replace(/_/g, ' ').toLowerCase().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

const getTipoVariant = (t) => {
  const variants = {
    'BIENES': 'primary',
    'SERVICIOS': 'info',
    'CONSULTORIA_LINEA': 'success',
    'CONSULTORIA_PRODUCTO': 'warning'
  };
  return variants[t] || 'secondary';
};

const getEstadoVariant = (e) => {
  const variants = {
    'BORRADOR': 'secondary',
    'EN_AUTORIZACION_RPA': 'warning',
    'AUTORIZADA': 'success',
    'RECHAZADA': 'danger',
    'EN_CERTIFICACION': 'info',
    'CERTIFICADA': 'info',
    'EN_SELECCION': 'primary',
    'EN_ADJUDICACION': 'warning',
    'ADJUDICADA': 'success',
    'EN_CONTRATACION': 'primary',
    'CONTRATADA': 'success',
    'EN_RECEPCION': 'warning',
    'RECIBIDA': 'dark',
    'CONCLUIDA': 'light'
  };
  return variants[e] || 'secondary';
};
</script>

<style scoped>
.card {
  margin-bottom: 0;
}

.table-borderless td {
  padding: 0.3rem 0;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}
</style>
